<div class="video-top-section">
    <div class="app-l-container">
        <div class="app-l-page__navigation">
            <div class="app-l-page__previous">
                <button
                    aria-label="Go to previous page"
                    class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20"
                    (click)="goBack()"
                    (keypress)="goBack()">
                    <svg-icon icon="arrowLeft" class="w-100 h-100"></svg-icon>
                </button>
            </div>
            <nav aria-label="Breadcrumb" class="app-l-page__breadcrumbs">
                <ul class="breadcrumbs-list">
                    <li class="breadcrumbs-list-item">
                        <a
                            translate
                            [routerLink]="['/app/series']"
                            aria-label="Go to Series"
                            >series.title</a
                        >
                    </li>
                    <li
                        class="breadcrumbs-list-item app-l-current-page"
                        aria-current="page"
                        translate>
                        series.seriesTypes.video
                    </li>
                </ul>
            </nav>
        </div>
        <div class="app-l-video-banner">
            <div class="app-l-video-banner__left">
                <h1 class="app-l-video-banner__heading" translate>
                    series.seriesTypes.video
                </h1>
                <!-- <h6 class="app-l-video-banner__desc" translate>

                </h6> -->
            </div>
        </div>
    </div>
</div>

<div class="app-l-page-wrap">
    <page-loader *ngIf="!loaded"></page-loader>

    <div id="page-theory" *ngIf="loaded">
        <div class="app-l-page-header-block">
            <div class="app-l-page-title-block">
                <!-- <h2 id="section-title" class="app-l-page-title" translate>
                    series.seriesTypes.video
                </h2>
                <span class="app-l-count">{{ count }}</span>
                <h4 translate>theory.total <span>{{count}}</span></h4> -->
            </div>
            <!-- <div class="app-c-custom-select">
                <select class="app-c-form-control app-l-dsh__cat_select" [(ngModel)]="categorySelected"
                    (change)="onCategoryChange()">
            
                    <option *ngFor="let category of categoryList" [ngValue]="category.ID" [hidden]="category.hasVideos <= 0">
                        {{ category.Title | translate }}
                    </option>
            
                </select>
            </div>             -->

            <div class="app-c-custom-select">
                <div
                    class="app-c-select-trigger"
                    role="combobox"
                    aria-haspopup="listbox"
                    aria-autocomplete="none"
                    aria-label="Select category"
                    aria-controls="theory-category-options"
                    [attr.aria-expanded]="isOpen"
                    tabindex="0"
                    (click)="isOpen = !isOpen"
                    (keydown.enter)="isOpen = !isOpen"
                    (keydown.space)="$event.preventDefault(); isOpen = !isOpen"
                    (keydown.escape)="isOpen = false">
                    <span>
                        <ng-container *ngFor="let category of categoryList">
                            <ng-container *ngIf="categorySelected === category.ID">{{ category.Title | translate }}</ng-container>
                        </ng-container>
                    </span>
                </div>

                <ul id="theory-category-options" class="app-c-select-list" *ngIf="isOpen" role="listbox" aria-label="Category options">
                    <ng-container *ngFor="let category of categoryList">
                        <li *ngIf="category.hasVideos > 0" [class.is-selected]="categorySelected === category.ID"
                            role="option"
                            tabindex="0"
                            [attr.aria-selected]="categorySelected === category.ID"
                            (click)="categorySelected = category.ID; isOpen = false; onCategoryChange()"
                            (keydown.enter)="categorySelected = category.ID; isOpen = false; onCategoryChange()"
                            (keydown.space)="$event.preventDefault(); categorySelected = category.ID; isOpen = false; onCategoryChange()">
                            {{ category.Title | translate }}
                        </li>
                    </ng-container>
                </ul>
            </div>
        </div>

        <div class="app-l-course__list" *ngIf="filteredCourseList.length != 0">
            <div
                class="app-l-course__items"
                *ngFor="let item of filteredCourseList | keyvalue">
                <div
                    class="course-card"
                    [attr.aria-label]="item.name + ' Series'">
                    <div class="card-body">
                        <!-- <div class="check"></div> -->
                        <div class="app-l-course__image">
                            <img
                                class="img-responsive"
                                [defaultImage]="
                                    './assets/img/course_image_default.svg'
                                "
                                [lazyLoad]="item.value.courseImage" />
                            <div class="app-l-course__cnt">
                                <div class="app-l-course__length">
                                    <span translate
                                        >theory.length
                                        <span class="app-l-length__duration">{{
                                            item.value.length
                                        }}</span>
                                    </span>
                                    <!-- <span translate>{{'theory.courses.' + item.value.key + '.length'}}</span> -->
                                </div>
                                <h2 class="app-l-course__title" translate>
                                    {{ item.value.name }}
                                </h2>
                            </div>

                            <div translate class="app-l-course__video-status">
                                <div
                                    *ngIf="
                                        !item.value.completed &&
                                        item.value.courseProgress ===
                                            'inprogress'
                                    "
                                    class="app-l-course__badge app-l-course__badge-inprogress">
                                    <svg-icon
                                        icon="timer"
                                        class="app-l-course__badge-icon"
                                        alt="timer"></svg-icon>
                                    <span
                                        class="app-l-course__badge-text"
                                        translate
                                        >theory.inProgress</span
                                    >
                                </div>
                                <div
                                    *ngIf="item.value.completed"
                                    class="app-l-course__badge app-l-course__badge-completed">
                                    <svg-icon
                                        icon="tick-circle"
                                        class="app-l-course__badge-icon"
                                        alt="tick-circle"></svg-icon>
                                    <span
                                        class="app-l-course__badge-text"
                                        translate
                                        >theory.completed</span
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="card-content">
                            <!-- <span class="status-badge" translate>{{item.value.completed ? 'Completed':
                            'In-Progress'}}</span> -->

                            <p [innerHtml]="item.value.description"></p>
                        </div>
                    </div>
                    <div class="card-footer">
                        <button
                            tabindex="0"
                            class="app-c-btn app-c-btn--secondary app-c-btn--curve"
                            [attr.aria-label]="
                                item.value.name +
                                ' Series' +
                                (item.value.completed ? ' Restart' : ' Start')
                            "
                            translate
                            (click)="goToCourse(item.value)"
                            (keypress)="goToCourse(item.value)">
                            {{
                                item.value.completed
                                    ? 'theory.restart'
                                    : 'theory.start'
                            }}
                        </button>
                        <span class="app-l-course-video-count"
                            >{{ item.value.videoCount }}
                            <span translate>theory.videos</span></span
                        >
                    </div>
                    <!-- <div class="panel-footer">
                        <a
                        class="text-view-results"
                        (click)="goToCourse(item.value)"
                        translate
                        >theory.go</a
                        >
                    </div> -->
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <ng-container *ngIf="filteredCourseList.length == 0">
            <div class="empty-card">
                <div class="app-dm-positive-cards" translate>series.noData</div>
            </div>
        </ng-container>
    </div>
</div>
